import clsx from 'clsx';
import styles from './Pill.module.scss';
import { type ReactNode } from 'react';

export type PillColor =
  | 'primary'
  | 'accent'
  | 'secondary'
  | 'error'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info';

interface Props {
  children: ReactNode;
  color?: PillColor;
}

export function Pill({ children, color = 'primary' }: Props) {
  return (
    <span className={clsx(styles['pill'], styles[`pill-color-${color}`])}>
      {children}
    </span>
  );
}
